type NestedObject = Record<
  string,
  Record<string, unknown> | string | string[] | null
>;

export function deepReplaceObjectValue(
  object: NestedObject,
  needle: string,
  replacement: string | null,
): void {
  if (typeof object === 'object' && object !== null) {
    if (Array.isArray(object)) {
      for (let index = 0; index < object.length; index += 1) {
        if (typeof object[index] === 'object' && object[index] !== null) {
          deepReplaceObjectValue(
            object[index] as NestedObject,
            needle,
            replacement,
          );
        } else if (object[index] === needle) {
          object[index] = replacement;
        }
      }
    } else {
      for (const key in object) {
        if (Object.prototype.hasOwnProperty.call(object, key)) {
          if (typeof object[key] === 'object' && object[key] !== null) {
            deepReplaceObjectValue(
              object[key] as NestedObject,
              needle,
              replacement,
            );
          } else if (object[key] === needle) {
            object[key] = replacement;
          }
        }
      }
    }
  }
}
